import config from 'config';
import { random } from 'lodash';

const AD_FALLBACK_SOURCES = [
  {
    poster: `${config.cdnUrl}/kbyg/videos/thumbnails/preroll_surfline_house_sick_sep23.jpg`,
    src: `${config.cdnUrl}/kbyg/videos/preroll_surfline_house_sick_sep23.mp4`,
  },
  {
    poster: `${config.cdnUrl}/kbyg/videos/thumbnails/preroll_surfline_rewind_sep23.jpg`,
    src: `${config.cdnUrl}/kbyg/videos/preroll_surfline_rewind_sep23.mp4`,
  },
];

export const getFallbackAd = () => {
  const randomAdIndex = random(1, AD_FALLBACK_SOURCES.length - 1);
  return {
    poster: AD_FALLBACK_SOURCES[randomAdIndex].poster,
    sources: [
      {
        src: AD_FALLBACK_SOURCES[randomAdIndex].src,
        type: 'video/mp4',
      },
    ],
  };
};
